import { lazy } from 'react'

export const DashboardNavigate = lazy(() => import('./dashboard-navigate'))
export const Dashboard = lazy(() => import('./dashboard'))
